var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.233 3.804a.75.75 0 0 1 .556 0l10.511 4.2a.75.75 0 0 1 0 1.392l-10.51 4.2a.75.75 0 0 1-.557 0L.722 9.397a.75.75 0 0 1 0-1.392zM3.02 8.7l8.49 3.392 8.49-3.392-8.49-3.392z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.022 8.005a.75.75 0 0 1 .75.75v4.612a.75.75 0 1 1-1.5 0V8.755a.75.75 0 0 1 .75-.75zM5.778 10.163a.75.75 0 0 1 .75.75v5.884a9.132 9.132 0 0 0 1.246.87c.947.553 2.25 1.083 3.737 1.083s2.79-.53 3.738-1.082a9.136 9.136 0 0 0 1.245-.87v-5.885a.75.75 0 1 1 1.5 0v6.22a.75.75 0 0 1-.224.535l-.526-.535.526.535-.001.002-.003.002-.008.008-.027.026-.096.088c-.082.073-.2.174-.35.295-.3.24-.736.558-1.282.876-1.087.632-2.652 1.285-4.492 1.285-1.84 0-3.405-.653-4.492-1.285a10.619 10.619 0 0 1-1.282-.876 8.323 8.323 0 0 1-.445-.383l-.027-.026-.009-.008-.002-.002-.001-.001s-.001-.001.525-.536l-.526.535a.75.75 0 0 1-.224-.535v-6.22a.75.75 0 0 1 .75-.75z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/master-icon.d2a98a8b578e38585ae082d800b3d43f.svg";
export { ForwardRef as ReactComponent };